import { createFileRoute } from "@tanstack/react-router";
import { PageHead, Panel } from "@/project/components/dashboard-shell";
import { sampleDonations, formatINR } from "@/project/data/sample";

export const Route = createFileRoute("/institution/donations")({ component: InstDonations });

function InstDonations() {
  return (
    <>
      <PageHead title="Donations received" subtitle="Export, view receipts and respond to donors." />
      <Panel title="Donation log">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm">
            <thead className="text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
              <tr className="text-left"><th className="py-2.5">ID</th><th>Donor</th><th>Cause</th><th>Amount</th><th>Date</th><th className="text-right">Receipt</th></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {sampleDonations.map((d) => (
                <tr key={d.id} className="hover:bg-muted/30">
                  <td className="py-3 font-mono text-xs font-bold text-muted-foreground">{d.id}</td>
                  <td className="font-medium text-foreground">{d.donor}</td>
                  <td className="max-w-xs truncate text-muted-foreground">{d.cause}</td>
                  <td className="font-extrabold text-[var(--maroon)]">{formatINR(d.amount)}</td>
                  <td className="text-xs text-muted-foreground">{d.date}</td>
                  <td className="text-right"><button className="rounded-full border border-border px-3 py-1 text-xs font-semibold hover:bg-muted">Download</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Panel>
    </>
  );
}